<template>
    <ISelect class="i-select" :initValue="initValue" v-bind="props" :class="{ 'is-error': isError }" @menuClick="inputHandler" />
</template>

<script>
import ISelect from "@/views/zhiji/bComponents/inputs/Select";

export default {
    name: "Selector",
    components: {
        ISelect
    },
    props: ["value", "widget", "verifyInfo", "rules"],
    computed: {
        props() {
            return this.widget.props;
        },
        initValue() {
            return this.value;
        },
        isError() {
            return this.verifyInfo && this.verifyInfo.isValid === false;
        }
    },
    methods: {
        inputHandler(item) {
            this.$emit("change", item.value);
            this.verifyHandler(item);
        },
        verifyHandler(item) {
            if (!this.rules.some(rule => rule.required)) {
                return;
            }

            const verifyInfo = item ? { isValid: true, message: "" } : { isValid: false, message: "请输入必要内容" };
            this.$emit("verify", verifyInfo);
        }
    }
};
</script>

<style scoped lang="less">
.i-select {
    margin: 0;
}
.is-error {
    /deep/ input {
        border: 1px solid #f33535;
    }
}
</style>
